module.exports = __webpack_public_path__ + "static/media/icon_w.32fef2b2.svg";